import React from 'react';
import { Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { Copy } from '../../../../../../../shared/ui/Copy';
import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';

const { Text } = Typography;

export const CloudpaymentsStepInit = () => {
    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 1. Регистрация CloudPayments'} />

            <StepList>
                <Text>Для подключения оплаты необходимо:</Text>
                <Text>
                    1. перейти по{' '}
                    <Link to={'https://cloudpayments.ru'} target={'_blank'}>
                        партнерской ссылке
                    </Link>{' '}
                    и зарегистрироваться в системе CloudPayments
                </Text>
                <Text>
                    2. в настройках сайта получить “Public ID” и “Пароль для
                    API”
                </Text>
                <Text>
                    3. перейти во вкладку «Уведомления» и включить уведомление
                    «Pay»
                </Text>
                <Text>
                    4. в поле «URL сайта» указать ссылку:{' '}
                    <Copy
                        text={'https://api.spodial.com/cloud-payments/notify'}
                    />
                </Text>
            </StepList>
        </Flex>
    );
};
